"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCandidateStorefrontCount = exports.EXPERIMENT_CANDIDATE_STOREFRONT_COUNT_OPTIONS = exports.MAX_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT = exports.DEFAULT_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT = exports.MIN_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT = void 0;
exports.MIN_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT = 1;
exports.DEFAULT_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT = 10;
exports.MAX_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT = 10;
exports.EXPERIMENT_CANDIDATE_STOREFRONT_COUNT_OPTIONS = Array.from({ length: exports.MAX_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT }, (_, i) => i + 1);
const normalizeCandidateStorefrontCount = (count) => {
    if (!count ||
        !Number.isFinite(count) ||
        count < exports.MIN_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT) {
        return exports.DEFAULT_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT;
    }
    return Math.min(Math.floor(count), exports.MAX_EXPERIMENT_CANDIDATE_STOREFRONT_COUNT);
};
exports.normalizeCandidateStorefrontCount = normalizeCandidateStorefrontCount;
